import { render, staticRenderFns } from "./backgroundTaskManagement.vue?vue&type=template&id=57ada599&scoped=true"
import script from "./backgroundTaskManagement.vue?vue&type=script&lang=js"
export * from "./backgroundTaskManagement.vue?vue&type=script&lang=js"
import style0 from "./backgroundTaskManagement.vue?vue&type=style&index=0&id=57ada599&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ada599",
  null
  
)

export default component.exports